import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import { Primitive } from "@radix-ui/react-primitive";
import { forwardRef } from "react";
export const chip = tailwindVariants({
    base: "inline-flex items-center justify-between gap-1 truncate font-medium",
    variants: {
        appearance: {
            filled: "border-0",
            outline: "border"
        },
        color: {
            black: "",
            blue: "",
            green: "",
            grey: "",
            "light-blue": "",
            "light-green": "",
            "light-grey": "",
            "light-orange": "",
            "light-pink": "",
            "light-purple": "",
            "light-red": "",
            "light-teal": "",
            "light-yellow": "",
            orange: "",
            pink: "",
            purple: "",
            red: "",
            teal: "",
            transparent: "",
            yellow: ""
        },
        shape: {
            rounded: "rounded-full",
            rectangular: "rounded-4"
        },
        size: {
            small: "h-5 text-10",
            medium: "h-6 text-12",
            large: "h-7 text-14",
            "extra-large": "h-8 text-14"
        }
    },
    compoundVariants: [
        {
            appearance: "filled",
            color: "black",
            className: "bg-black text-white"
        },
        {
            appearance: "outline",
            color: "black",
            className: "border-black text-black"
        },
        {
            appearance: "filled",
            color: "blue",
            className: "bg-blue-5 text-blue-12"
        },
        {
            appearance: "outline",
            color: "blue",
            className: "border-blue-5 text-blue-9"
        },
        {
            appearance: "filled",
            color: "green",
            className: "bg-green-7 text-teal-12"
        },
        {
            appearance: "outline",
            color: "green",
            className: "border-green-5 text-green-9"
        },
        {
            appearance: "filled",
            color: "grey",
            className: "bg-grey-4 text-grey-12"
        },
        {
            appearance: "outline",
            color: "grey",
            className: "border-grey-5 text-grey-9"
        },
        {
            appearance: "filled",
            color: "light-blue",
            className: "bg-blue-3 text-blue-12"
        },
        {
            appearance: "outline",
            color: "light-blue",
            className: "border-blue-5 text-blue-9"
        },
        {
            appearance: "filled",
            color: "light-green",
            className: "bg-green-4 text-green-12"
        },
        {
            appearance: "outline",
            color: "light-green",
            className: "border-green-5 text-green-9"
        },
        {
            appearance: "filled",
            color: "light-grey",
            className: "bg-grey-4 text-grey-12"
        },
        {
            appearance: "outline",
            color: "light-grey",
            className: "border-grey-3 text-grey-9"
        },
        {
            appearance: "filled",
            color: "light-orange",
            className: "bg-orange-2 text-orange-12"
        },
        {
            appearance: "outline",
            color: "light-orange",
            className: "border-orange-3 text-orange-9"
        },
        {
            appearance: "filled",
            color: "light-pink",
            className: "bg-pink-2 text-pink-12"
        },
        {
            appearance: "outline",
            color: "light-pink",
            className: "border-pink-3 text-pink-9"
        },
        {
            appearance: "filled",
            color: "light-purple",
            className: "bg-purple-2 text-purple-12"
        },
        {
            appearance: "outline",
            color: "light-purple",
            className: "border-purple-3 text-purple-9"
        },
        {
            appearance: "filled",
            color: "light-red",
            className: "bg-red-4 text-red-12"
        },
        {
            appearance: "outline",
            color: "light-red",
            className: "border-red-3 text-red-9"
        },
        {
            appearance: "filled",
            color: "light-teal",
            className: "bg-teal-4 text-teal-12"
        },
        {
            appearance: "outline",
            color: "light-teal",
            className: "border-teal-3 text-teal-9"
        },
        {
            appearance: "filled",
            color: "light-yellow",
            className: "bg-yellow-3 text-yellow-12"
        },
        {
            appearance: "outline",
            color: "light-yellow",
            className: "border-yellow-3 text-yellow-9"
        },
        {
            appearance: "filled",
            color: "orange",
            className: "bg-orange-4 text-orange-12"
        },
        {
            appearance: "outline",
            color: "orange",
            className: "border-orange-5 text-orange-9"
        },
        {
            appearance: "filled",
            color: "pink",
            className: "bg-pink-4 text-pink-12"
        },
        {
            appearance: "outline",
            color: "pink",
            className: "border-pink-5 text-pink-9"
        },
        {
            appearance: "filled",
            color: "purple",
            className: "bg-purple-6 text-purple-12"
        },
        {
            appearance: "outline",
            color: "purple",
            className: "border-purple-5 text-purple-9"
        },
        {
            appearance: "filled",
            color: "red",
            className: "bg-red-7 text-red-12"
        },
        {
            appearance: "outline",
            color: "red",
            className: "border-red-5 text-red-9"
        },
        {
            appearance: "filled",
            color: "teal",
            className: "bg-teal-6 text-teal-12"
        },
        {
            appearance: "outline",
            color: "teal",
            className: "border-teal-5 text-teal-9"
        },
        {
            appearance: "filled",
            color: "transparent",
            className: "bg-transparent text-grey-12"
        },
        {
            appearance: "outline",
            color: "transparent",
            className: "border-transparent text-grey-12"
        },
        {
            appearance: "filled",
            color: "yellow",
            className: "bg-yellow-6 text-yellow-12"
        },
        {
            appearance: "outline",
            color: "yellow",
            className: "border-yellow-5 text-yellow-9"
        },
        {
            shape: "rounded",
            size: "small",
            class: "px-2"
        },
        {
            shape: "rounded",
            size: [
                "medium",
                "large",
                "extra-large"
            ],
            class: "px-3"
        },
        {
            shape: "rectangular",
            size: "small",
            className: "px-1"
        },
        {
            shape: "rectangular",
            size: [
                "medium",
                "large",
                "extra-large"
            ],
            className: "px-1.5"
        }
    ],
    defaultVariants: {
        appearance: "filled",
        color: "grey",
        shape: "rectangular",
        size: "small"
    }
});
export const Chip = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { appearance, className, color = "grey", shape = "rectangular", size = "small", ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(Primitive.div, {
        className: chip({
            appearance,
            color,
            shape,
            size,
            className
        }),
        "data-testid": "CHIP",
        ...restOfProps,
        ref: forwardedRef
    });
});
Chip.displayName = "Chip";
